import ArticleItem from './Item';
import ArticleActions from './Actions';
import ArticleStatusLabel from './StatusLabel';

export default {
  ArticleItem,
  ArticleActions,
  ArticleStatusLabel,
};
